import styled from "styled-components";
import { Fonts } from "yuka";

const StyledHotkeyPrompt = styled(Fonts.Body1theme30)`
  white-space: nowrap;
`;

// eslint-disable-next-line import/prefer-default-export
export { StyledHotkeyPrompt };
